const anchorLinks = Array.from(document.querySelectorAll(".anchor-link"));

anchorLinks.forEach(function (link) {
    let anchor = null;
    if (link.getAttribute("href") === null) {
        anchor = link.getAttribute("data-anchor");
    } else {
        anchor = link.getAttribute("href");
    }

    link.addEventListener("click", function () {
        gotoAnchor(anchor);
    });
});


function gotoAnchor(anchor) {

    const targetElement = document.querySelector(anchor);
    if (targetElement) {

        // Devo controllare se lo scroll va verso l'alto. Se verso l'alto devo scrollare di più aggiungendo l'altezza della navbar
        let offset = 0;
        
        if (window.scrollY > targetElement.getBoundingClientRect().top) {
            const pageHeader = document.querySelector("#pageHeader");

            if (pageHeader) {
                offset = pageHeader.offsetHeight + 20;
            }

        }

        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: targetPosition, behavior: "smooth" });

        setTimeout(() => {
            history.replaceState(null, null, " ");
        }, 10);

    }
}